import { bindActionCreators, compose } from 'redux';
import { DragSource } from 'react-dnd';
import { connect } from '../../../../../common/react-redux';
import { ItemTypes, dragSource, collectDrag, DropTargetCreator } from '../../../../../common/components/shared/drag_and_drop/dragAndDropUtils';
import { newHoverPosition as newHoverPositionAction } from '../../../../../common/actions/dragAndDrop';
import { set as setUI } from '../../../../../common/actions/ui';
import { openMoveImmutableModal } from '../../../../../common/actions/modal';
import { moveQuizEntry as moveQuizEntryAction } from '../../../../api/quizEntries';
import { moveTemporaryQuizEntry as moveTemporaryQuizEntryAction } from '../../../../../common/actions/modifications';
import Stimulus from './presenter';
import { SIDEBAR_ITEM_REF } from '@instructure/quiz-common';
import { getActiveQuiz } from '../../../../../common/selectors/quizzes';
export var mapStateToProps = function mapStateToProps() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Map();
  var props = arguments.length > 1 ? arguments[1] : undefined;
  var activeQuiz = getActiveQuiz(state);
  var quizEntriesIncludingTemp = activeQuiz.getWorkingQuizEntries();
  var itemsCollectionSize = quizEntriesIncludingTemp.size || quizEntriesIncludingTemp.length || 0;
  var dndPosition = state.getIn(['dragAndDrop', 'position']);
  var draggingAboveHalf = state.getIn(['dragAndDrop', 'aboveHalf'], false);
  var draggingOver = dndPosition === props.quizEntry.position;
  var dropIntoEmptyStimulus = state.getIn(['dragAndDrop', 'intoEmptyStimulus']);
  return {
    childEntries: props.quizEntry.getNestedEntries(),
    dndPositionObj: draggingOver ? state.get('dragAndDrop') : null,
    // for DnD
    draggingOver: draggingOver && props.draggingInSidebar,
    draggingAboveHalf: draggingOver && draggingAboveHalf,
    dropIntoEmptyStimulus: draggingOver && dropIntoEmptyStimulus,
    itemsCollectionSize: itemsCollectionSize,
    quizId: activeQuiz.id // forDnD
  };
};
export var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    moveTemporaryQuizEntry: bindActionCreators(moveTemporaryQuizEntryAction, dispatch),
    // for DnD
    moveQuizEntry: bindActionCreators(moveQuizEntryAction, dispatch),
    // for DnD
    newHoverPosition: bindActionCreators(newHoverPositionAction, dispatch),
    // for DnD
    openMoveImmutableModal: bindActionCreators(openMoveImmutableModal, dispatch),
    // for DnD
    setUi: bindActionCreators(setUI, dispatch) // for DnD
  };
};
export var connectToDragSource = function connectToDragSource(Component) {
  return DragSource(
  // ItemTypes.QUIZ_ENTRY associates this component drag source with a name
  // dragSource specifies functions React DnD will call for events with this component
  // collectDrag injects props into component
  ItemTypes.QUIZ_ENTRY, dragSource, collectDrag)(Component);
};
export default compose(connect(mapStateToProps, mapDispatchToProps), DropTargetCreator(SIDEBAR_ITEM_REF), connectToDragSource)(Stimulus);